export default {
    settings: {
        title: 'Server settings',
        navigation: {
            enableUserInvitationEmails: 'Enable invitation Emails'
        },
        descriptions: {
            enableUserInvitationEmails: 'Enable new user invitation emails'
        },
        messages: {
            successMessage: 'Setting updated successfully',
            errorMessage: 'Error updating Setting'
        }
    }
};
